const unsavedFormChanges = {
  SET_FORM_DATA: 'SET_FORM_DATA',
  SET_FORM_STATUS: 'SET_FORM_STATUS',
  RESET_FORM_CHANGES: 'RESET_FORM_CHANGES',
};

export default unsavedFormChanges;
